var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6626 9.77098H20.7221C18.423 9.77502 16.5605 11.591 16.5563 13.8327C16.5532 16.0794 18.4178 17.9034 20.7221 17.9065H25.6667V18.2634C25.6667 22.1825 23.2909 24.5 19.2703 24.5H8.73086C4.70923 24.5 2.33337 22.1825 2.33337 18.2634V9.7275C2.33337 5.80839 4.70923 3.5 8.73086 3.5H19.2661C23.2867 3.5 25.6626 5.80839 25.6626 9.7275V9.77098ZM7.86286 9.7619H14.4429H14.447H14.4553C14.9479 9.75988 15.3461 9.36857 15.344 8.88728C15.342 8.407 14.9396 8.01873 14.447 8.02075H7.86286C7.37338 8.02277 6.97619 8.41003 6.97412 8.88829C6.97205 9.36857 7.37027 9.75988 7.86286 9.7619Z",
    fill: "#3994DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.7104 14.346C18.9544 15.4558 19.9273 16.2365 21.0381 16.2162H24.8297C25.2919 16.2162 25.6667 15.8334 25.6667 15.3603V12.4068C25.6658 11.9347 25.2919 11.5509 24.8297 11.5499H20.9488C19.6853 11.554 18.6648 12.6028 18.6668 13.8953C18.6668 14.0465 18.6816 14.1978 18.7104 14.346",
    fill: "#3994DE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 13.8833,
    rx: 1.16667,
    ry: 1.16667,
    fill: "#3994DE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2a983a2f5ec53d8e335fa759d02c7778.svg";
export { ForwardRef as ReactComponent };